import { render, staticRenderFns } from "./tracker-multinational-organizations-widget.vue?vue&type=template&id=16d852b6&scoped=true&"
import script from "./tracker-multinational-organizations-widget.vue?vue&type=script&lang=js&"
export * from "./tracker-multinational-organizations-widget.vue?vue&type=script&lang=js&"
import style0 from "./tracker-multinational-organizations-widget.vue?vue&type=style&index=0&id=16d852b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d852b6",
  null
  
)

export default component.exports